import PropTypes from 'prop-types'
import React from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import classes from './Textarea.module.scss'

export class Textarea extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    textareaRef: PropTypes.func,
    maxLength: PropTypes.number,
    value: PropTypes.string
  }

  static defaultProps = {
    maxRows: 6
  }

  constructor (props) {
    super(props)

    this.setRef = this.setRef.bind(this)
  }

  setRef (ref) {
    this.textarea = ref
    if (this.props.textareaRef) this.props.textareaRef(ref)
  }

  render () {
    const {
      textareaRef,
      className,
      maxLength,
      value,
      ...props
    } = this.props

    return (
      <div className={classes.textarea}>
        <TextareaAutosize
          {...props}
          ref={this.setRef}
          className={'form-control' + (className ? (' ' + className) : '')}
          maxLength={maxLength}
          value={value}
        />
          {maxLength &&
            <div className={classes.remainingCharacters}>
              {value.length}{'/'}{maxLength}
            </div>
          }
      </div>
    )
  }
}

export default Textarea

